import chroma from "chroma-js";
import type { SviQuintile } from "../types/equity";

export const riskScale = chroma
  .scale(["#ffffcc", "#feb24c", "#fc4e2a", "#800026"])
  .domain([0, 0.4, 0.7, 1.0]);

export const SVI_COLORS: Record<SviQuintile, string> = {
  Q1: "#1a9850",
  Q2: "#91cf60",
  Q3: "#ffffbf",
  Q4: "#fc8d59",
  Q5: "#d73027",
};

export function riskBadgeColor(pHat: number): string {
  if (pHat >= 0.8) return "#d73027";
  if (pHat >= 0.6) return "#fc8d59";
  if (pHat >= 0.4) return "#fee08b";
  return "#91cf60";
}

export function riskLabel(pHat: number): string {
  if (pHat >= 0.8) return "CRITICAL";
  if (pHat >= 0.6) return "HIGH";
  if (pHat >= 0.4) return "MODERATE";
  return "LOW";
}
